import React from 'react';
import Icon from '../common/components/Icon';
import { useTranslations } from '../localization/useTranslations';

interface SubscribeButtonProps {
  onSubscribe: () => void;
  buttonType: 'button' | 'link';
  type: 'author' | 'topic';
  isSubscribed: boolean;
  extraClassMod?: string;
}

const SubscribeButton: React.FC<SubscribeButtonProps> = ({
  onSubscribe,
  type,
  buttonType,
  isSubscribed,
  extraClassMod,
}) => {
  const translations = useTranslations();

  const buttonClass =
    buttonType === 'button' ? 'author__follow-button button button--primary button--medium' : 'author__follow-link';

  const extraClass = extraClassMod ? extraClassMod : '';

  const label = isSubscribed
    ? translations?.authorAndTopic?.unfollow || 'Unfollow'
    : (type === 'topic' ? translations?.authorAndTopic?.followTopic : translations?.authorAndTopic?.followAuthor) ||
      'Follow';

  return (
    <button className={`${buttonClass} ${extraClass}`} onClick={onSubscribe} aria-label={label}>
      {isSubscribed ? <Icon name="minus" size="small" /> : <Icon name="plus" size="small" />}
      <span className={buttonType === 'button' ? 'button-text' : 'link-underline-14'}>{label}</span>
    </button>
  );
};

export default SubscribeButton;
